import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../../common/http-helpers/http.wrapper";
var PatientAccountProxy = /** @class */ (function () {
    function PatientAccountProxy(httpWrapper) {
        this.httpWrapper = httpWrapper;
    }
    PatientAccountProxy.prototype.locatePatient = function (patientData) {
        return this.httpWrapper.putAnon('PatientPortalAccount', 'LocatePatient', patientData, null);
    };
    PatientAccountProxy.prototype.createPatientAccount = function (patientDataWithAccountDetails) {
        return this.httpWrapper.putAnon('PatientPortalAccount', 'createPatientAccount', patientDataWithAccountDetails, null);
    };
    PatientAccountProxy.prototype.generatePatientUserName = function (patientData) {
        return this.httpWrapper.putAnon('PatientPortalAccount', 'GeneratePatientUserName', patientData, null).pipe(map(function (res) { return res.userName; }));
    };
    PatientAccountProxy.prototype.getPatientUserName = function (patientData) {
        return this.httpWrapper.putAnon('PatientPortalAccount', 'GetPatientUserName', patientData, null).pipe(map(function (res) { return res.userName; }));
    };
    PatientAccountProxy.prototype.generateOneTimeCode = function (patientData) {
        return this.httpWrapper.putAnon('PatientPortalAccount', 'GenerateOneTimeCode', patientData, null);
    };
    PatientAccountProxy.prototype.validateOneTimeCode = function (oneTimeCodeData) {
        return this.httpWrapper.putAnon('PatientPortalAccount', 'ValidateOneTimeCode', oneTimeCodeData, null);
    };
    PatientAccountProxy.prototype.changePassword = function (userCredentials) {
        return this.httpWrapper.putAnon('PatientPortalAccount', 'ChangePassword', userCredentials, null);
    };
    PatientAccountProxy.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PatientAccountProxy_Factory() { return new PatientAccountProxy(i0.ɵɵinject(i1.HttpWrapper)); }, token: PatientAccountProxy, providedIn: "root" });
    return PatientAccountProxy;
}());
export { PatientAccountProxy };
